// Vendor Libraries

try {

    window.$ = window.jQuery = require('jquery');
    window.jQueryBridget     = require('jquery-bridget');
    window.Masonry           = require('masonry-layout');
    window.Selectric         = require('jquery-selectric');
    window.flickity          = require('flickity');
    window.LazyLoad          = require('vanilla-lazyload');

    // make Masonry a jQuery plugin
    jQueryBridget( 'masonry', Masonry, $ );

    // TWBS
    window.Popper = require('@popperjs/core').default;

} catch (e) {
  console.log(e);
}

// Components
require('./components/animation');
require('./components/disclaimer');
require('./components/lazyLoad');
require('./components/plugins');
require('./components/portfolioFilters');
require('./components/postFilters');
require('./components/scrollTracker');
require('./components/teamFilters');
require('./components/utilities');

// Blocks
require('./blocks/accordion');
require('./blocks/content-box');
require('./blocks/info-box');
require('./blocks/location-grid');
require('./blocks/location-map');
require('./blocks/masthead');
require('./blocks/responsive-slider');
require('./blocks/testimonials-carousel');

require('./blocks/hig-banner');
require('./blocks/repurchase-documents');
require('./blocks/unit-class');
require('./blocks/sec-fillings');
require('./blocks/jurisdictional-disclosures');
require('./blocks/popup');
require('./blocks/sharedoc');



// require('./blocks/stats');
require('./blocks/tabs');
require('./blocks/wp-menu');
